import { DATE_ONLY_DISPLAY_FORMAT, formatDateOnly } from '@/config';
import moment from 'moment';
import React from 'react';
import DatePicker, { ReactDatePickerProps } from 'react-datepicker';

interface pickerProps extends Omit<ReactDatePickerProps, 'placeholderText'> {
  placeholder?: string | undefined;
}
export default function NtaDatePicker({ placeholder, value, onChange, ...props }: pickerProps) {
  const onDateChange = (date: any, event: any) => {
    if (date) {
      onChange(formatDateOnly(date) as any, event);
    } else {
      onChange(null, event);
    }
  };
  return (
    <DatePicker
      placeholderText={placeholder}
      isClearable
      showIcon
      onChange={onDateChange}
      selected={value ? moment(value).toDate() : undefined}
      className="agent-dashboard-datepicker"
      {...props}
    />
  );
}
